module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/92bd85301d6c7cdcb7cccfa2e65fad82.png";